import * as actionTypes from '../actions/actionTypes';

export default function seFlowReducer(state = {}, action: any): {}  {
    switch (action.type){
        case "SET_DISABLE_LAUNCH_EVENTS":{
            const stateLocation = action.payload.stateLocation;
            const newValue = action.payload.value;
            return Object.assign({}, state, {
                [stateLocation]: newValue,
            });
        }
        default:{
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./modules/launch-offers-post-message-handling/reducers/seFlowReducer.ts